;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { pluralize } from '@qogita/format/string'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Badge } from '@qogita/ui/v2/badge'
import { Button } from '@qogita/ui/v2/button'
import { Icon } from '@qogita/ui/v2/icon'
import clsx from 'clsx'
import { Suspense } from 'react'
import { DeprecatedTooltip } from 'src/components/deprecated/deprecated-tooltip'
import { useSuspenseExpiringPriceLists } from 'src/deprecated/hooks/api/useExpiringPriceLists'

type Props = {
  className?: string
}

function ExpiringPriceListsInner() {
  const { sources, totalResults } = useSuspenseExpiringPriceLists()

  return (
    <div className={clsx({ 'pb-6': sources.length > 0 })}>
      <div
        className={clsx('flex flex-row items-center p-6', {
          'pb-3': sources.length > 0,
        })}
      >
        <Icon
          name="heroicons/outline/exclamation-triangle"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="text-semantic-caution-bright mr-3 size-6"
        />
        <h3 className="typography-header-lg-bold flex items-center leading-7">
          {pluralize({ word: 'expiring price list', count: totalResults })}
        </h3>
      </div>

      <div className="max-h-60 overflow-y-auto px-6">
        <table className="w-full table-fixed">
          <thead className="sr-only">
            <tr>
              <th>Price list name</th>
              <th>Expiry</th>
              <th>Upload price list</th>
            </tr>
          </thead>

          <tbody>
            {sources.map((source) => {
              const displayName = source.name ?? ''

              // we are disabling the actions column for the integrated sellers
              // email & platform are not integrated, as sellers send their stocklist manually via email/platform
              const isSellerIntegrated =
                source.stocklistSourceType === 'custom_seller' ||
                source.stocklistSourceType === 'ftp' ||
                source.stocklistSourceType === 'ftp_tls' ||
                source.stocklistSourceType === 'sftp' ||
                source.stocklistSourceType === 'url'

              const disableActions =
                source.stockType === 'ON_FLOOR' && isSellerIntegrated
              return (
                <tr key={source.qid} className="h-[48px]">
                  <td className="flex flex-wrap items-center gap-x-2">
                    <p className="block truncate">{displayName}</p>
                  </td>

                  <td className="items-center px-6">
                    {source.expiresIn ? (
                      <Badge
                        emphasis="high"
                        variant={source.expiresIn.variant}
                        className="whitespace-nowrap"
                        help={source.expiresIn.tooltip}
                      >
                        {source.expiresIn.label}
                      </Badge>
                    ) : null}
                  </td>

                  <td className="flex justify-end">
                    {disableActions ? (
                      <DeprecatedTooltip content="On-floor stock is managed through your integration.">
                        <Button
                          type="button"
                          variant="text"
                          aria-label={`Upload new file for ${displayName}`}
                          aria-disabled
                        >
                          <Icon
                            name="heroicons/outline/arrow-up-on-square"
                            className="size-4.5"
                            aria-hidden
                          />
                          Upload
                        </Button>
                      </DeprecatedTooltip>
                    ) : (
                      <Anchor
                        variant="text"
                        href={`/price-lists/${source.qid}/upload-new-file`}
                        aria-label={`Upload new file for ${displayName}`}
                      >
                        <Icon
                          name="heroicons/outline/arrow-up-on-square"
                          className="size-4.5"
                          aria-hidden
                        />
                        Upload
                      </Anchor>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function Fallback() {
  return (
    <div className="flex flex-row items-center p-6">
      <div className="mr-3 rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <Icon
          name="heroicons/outline/exclamation-triangle"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="text-semantic-caution-bright invisible mr-3 size-6"
        />
      </div>
      <div className="rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <h3 className="invisible flex items-center text-base font-bold">
          {pluralize({ word: 'expiring price list', count: 3 })}
        </h3>
      </div>
    </div>
  )
}

export function ExpiringPriceLists({ className }: Props) {
  return (
    <article
      className={clsx(
        className,
        'bg-default relative rounded-lg border border-gray-200 shadow-xs',
      )}
    >
      <Suspense fallback={<Fallback />}>
        <ExpiringPriceListsInner />
      </Suspense>
    </article>
  )
}
